import { OverViewAgents, OverViewChart, OverViewTraffic } from "components/overview-components"


export const Overview = () => {




  return (
    <div className='w-full flex flex-col    '>
      <OverViewChart />
      <OverViewTraffic />
      <OverViewAgents />
    </div >
  )
}